module.exports = __webpack_public_path__ + "static/Platform for Conference-066ed0d699aa431bbc2cf779999d4aec.png";